import whitelabelDNSSettingsInfoRu from '@/locales/partials/agency/whitelabel-dns-settings-info-ru.html';
import whitelabelDNSSettingsInfoEn from '@/locales/partials/agency/whitelabel-dns-settings-info-en.html';
import whitelabelDNSSettingsInfoGe from '@/locales/partials/agency/whitelabel-dns-settings-info-ge.html';
import whitelabelDNSSettingsInfoDe from '@/locales/partials/agency/whitelabel-dns-settings-info-de.html';
// TODO: to be translated
import whitelabelDNSSettingsInfoCn from '@/locales/partials/agency/whitelabel-dns-settings-info-en.html';
import whitelabelDNSSettingsInfoPt from '@/locales/partials/agency/whitelabel-dns-settings-info-pt.html';

export default {
	uploading: {
		en: 'Uploading...',
		ge: 'ატვირთვა...',
		de: 'Hochladen...',
		ru: 'Загрузка...',
		cn: /* TODO: to be translated */'Uploading...',
		pt: 'Carregando...',
	},
	upload: {
		en: 'Upload',
		ge: 'ატვირთვა',
		de: 'Hochladen',
		ru: 'Загрузить',
		cn: /* TODO: to be translated */'Upload',
		pt: 'Carregar',
	},
	app_settings: {
		en: 'App Settings',
		ge: 'აპლიკაციის პარამეტრები',
		de: 'App-Einstellungen',
		ru: 'Настройки',
		cn: /* TODO: to be translated */'App Settings',
		pt: 'Configurações do Aplicativo',
	},
	whitelabel_settings: {
		en: 'White-label Settings',
		ge: 'პარამეტრები',
		de: 'White-label-Einstellungen',
		ru: 'Настройки White-label',
		cn: /* TODO: to be translated */'White-label Settings',
		pt: 'Configurações White-label',
	},
	whitelabel_dns_settings_info: {
		en: whitelabelDNSSettingsInfoEn,
		ge: whitelabelDNSSettingsInfoGe,
		de: whitelabelDNSSettingsInfoDe /* TODO: to be translated */,
		ru: whitelabelDNSSettingsInfoRu,
		cn: whitelabelDNSSettingsInfoCn,
		pt: whitelabelDNSSettingsInfoPt,
	},
	name: {
		en: 'Agency Name',
		ge: 'სააგენტოს სახელი',
		de: 'Agenturname',
		ru: 'Название агентства',
		cn: /* TODO: to be translated */'Name',
		pt: 'Nome da Agência',
	},
	language: {
		en: 'Language',
		ge: 'ენა',
		de: 'Sprache',
		ru: 'Язык',
		cn: /* TODO: to be translated */'Language',
		pt: 'Idioma',
	},
	default_language: {
		en: 'Default Language',
		ge: 'ნაგულისხმევი ენა',
		de: 'Standardsprache',
		ru: 'Язык по умолчанию',
		cn: /* TODO: to be translated */'Default Language',
		pt: 'Idioma Padrão',
	},
	enabled_payment_models: {
		en: 'enabled payment models',
		ge: 'ჩართული გადახდის მოდელები',
		de: 'aktivierte Zahlungsmodelle',
		ru: 'активные модели оплаты',
		cn: /* TODO: to be translated */'enabled payment models',
		pt: 'Modelos de pagamento habilitados',
	},
	default_balance: {
		en: 'Default account balance',
		ge: 'Default account balance' /* TODO: to be translated */,
		de: 'Default account balance' /* TODO: to be translated */,
		ru: 'Дефолтный баланс аккаунта',
		cn: /* TODO: to be translated */'Default account balance',
		pt: 'Saldo padrão da conta',
	},
	domain: {
		en: 'Domain',
		ge: 'დომენი',
		de: 'Domain',
		ru: 'Домен',
		cn: /* TODO: to be translated */'Domain',
		pt: 'Domínio',
	},
	help_text: {
		en: 'Creatives can be slightly cropped to accommodate suppliers’ screen specifications. We suggest to avoid positioning logos and text close to the edges. For best results, leave a 5% margin on each side.',
		ge: 'ზომები შეიძლება ოდნავ შემცირდეს მომწოდებლების ეკრანის სპეციფიკაციის დასაკმაყოფილებლად. ჩვენ გირჩევთ მოერიდოთ ლოგოების და ტექსტის კიდეებთან ახლოს განთავსებას. საუკეთესო შედეგისთვის, დატოვეთ 5% ზღვარი თითოეულ მხარეს.',
		de: 'Kreative können leicht beschnitten werden, um den Bildschirm-Spezifikationen der Anbieter zu entsprechen. Wir empfehlen, Logos und Text nicht zu nah am Rand zu platzieren. Für beste Ergebnisse lassen Sie einen Rand von 5% auf jeder Seite.',
		ru: 'Креативы могут быть слегка обрезаны, чтобы соответствовать спецификациям экрана поставщиков. Мы рекомендуем избегать размещения логотипов и текста близко к краям. Для достижения наилучших результатов оставьте отступ 5% с каждой стороны.',
		cn: /* TODO: to be translated */'Creatives can be slightly cropped to accommodate suppliers’ screen specifications. We suggest to avoid positioning logos and text close to the edges. For best results, leave a 5% margin on each side.',
		pt: 'Os criativos podem ser ligeiramente cortados para se adequarem às especificações da tela dos fornecedores. Sugerimos evitar posicionar logotipos e textos muito próximos às bordas. Para melhores resultados, deixe uma margem de 5% em cada lado.',
	},
	title: {
		en: 'Title',
		ge: 'სათაური',
		de: 'Titel',
		ru: 'Заголовок',
		cn: /* TODO: to be translated */'Title',
		pt: 'Título',
	},
	html_title: {
		en: 'HTML Title',
		ge: 'HTML სათაური',
		de: 'HTML-Titel',
		ru: 'HTML заголовок',
		cn: /* TODO: to be translated */'HTML Title',
		pt: 'Título HTML',
	},
	description: {
		en: 'Description',
		ge: 'აღწერა',
		de: 'Beschreibung',
		ru: 'Описание',
		cn: /* TODO: to be translated */'Description',
		pt: 'Descrição',
	},
	visual: {
		en: 'Visual',
		ge: 'ვიზუალური',
		de: 'Visuell',
		ru: 'Внешний вид',
		cn: /* TODO: to be translated */'Visual',
		pt: 'Visual',
	},
	main_color: {
		en: 'Main color',
		ge: 'მთავარი ფერი',
		de: 'Hauptfarbe',
		ru: 'Основной цвет',
		cn: /* TODO: to be translated */'Main color',
		pt: 'Cor principal',
	},
	interface_color: {
		en: 'Interface color',
		ge: 'ინტერფეისის ფერი',
		de: 'Schnittstellenfarbe',
		ru: 'Цвет интерфейса',
		cn: /* TODO: to be translated */'Interface color',
		pt: 'Cor da interface',
	},
	email_settings: {
		en: 'Email settings',
		ge: 'ელფოსტის პარამეტრები',
		de: 'E-Mail-Einstellungen',
		ru: 'Настройки писем',
		cn: /* TODO: to be translated */'Email settings',
		pt: 'Configurações de email',
	},
	welcome_text: {
		en: 'Weclome text',
		ge: 'მისალმების ტექსტი',
		de: 'Begrüßungstext',
		ru: 'Текст приветствия',
		cn: /* TODO: to be translated */'Weclome text',
		pt: 'Texto de boas-vindas',
	},
	schedule_title: {
		en: 'Default schedule',
		ge: 'ნაგულისხმევი განრიგი',
		de: 'Standardschema',
		ru: 'Расписание по умолчанию',
		cn: /* TODO: to be translated */'Default schedule',
		pt: 'Cronograma padrão',
	},
	help_title: {
		en: 'Setting up contacts to help the user',
		ge: 'კონტაქტების დაყენება მომხმარებლის დასახმარებლად',
		de: 'Einrichten von Kontakten zur Unterstützung des Benutzers',
		ru: 'Настройка контактов для помощи пользователю',
		cn: /* TODO: to be translated */'Setting up contacts to help the user',
		pt: 'Configuração de contatos para ajudar o usuário',
	},
	seo_title: {
		en: 'SEO optimization',
		ge: 'SEO ოპტიმიზაცია',
		de: 'SEO-Optimierung',
		ru: 'SEO оптимизация',
		cn: /* TODO: to be translated */'SEO optimization',
		pt: 'Otimização SEO',
	},
	yandex_metrika_id: {
		en: 'Yandex Metrika ID',
		ge: 'Yandex Metrika ID',
		de: 'Yandex Metrika ID',
		ru: 'Яндекс Метрика ID',
		cn: /* TODO: to be translated */'Yandex Metrika ID',
		pt: 'ID do Yandex Metrika',
	},
	footer: {
		en: 'Footer',
		ge: 'ფუტერი',
		de: 'Fußzeile',
		ru: 'Нижний колонтитул',
		cn: /* TODO: to be translated */'Footer',
		pt: 'Rodapé',
	},
	basic: {
		en: 'Basic',
		ge: 'ძირითადი',
		de: 'Basis',
		ru: 'Базовые',
		cn: /* TODO: to be translated */'Basic',
		pt: 'Básico',
	},
	logo: {
		en: 'Logo',
		ge: 'ლოგო',
		de: 'Logo',
		ru: 'Логотип',
		cn: /* TODO: to be translated */'Logo',
		pt: 'Logo',
	},
	favicon: {
		en: 'Favicon',
		ge: 'მინი სურათი',
		de: 'Favicon',
		ru: 'Иконка',
		cn: /* TODO: to be translated */'Favicon',
		pt: 'Favicon',
	},
	main_image: {
		en: 'Main image',
		ge: 'მთავარი სურათი',
		de: 'Hauptbild',
		ru: 'Основное изображение',
		cn: /* TODO: to be translated */'Main image',
		pt: 'Imagem principal',
	},
	footer_logo: {
		en: 'Footer logo',
		ge: 'ფუტერის ლოგო',
		de: 'Fußzeilen-Logo',
		ru: 'Нижний логотип',
		cn: /* TODO: to be translated */'Footer logo',
		pt: 'Logo do rodapé',
	},
	image_error: {
		en: 'The wrong image format is selected or the dimensions do not meet the specified ones',
		ge: 'შერჩეულია სურათის არასწორი ფორმატი ან ზომები არ შეესაბამება მითითებულს',
		de: 'Das falsche Bildformat wurde ausgewählt oder die Abmessungen entsprechen nicht den angegebenen',
		ru: 'Выбран неподходящий формат изображения или размеры не соотвествуют указанным',
		cn: /* TODO: to be translated */'The wrong image format is selected or the dimensions do not meet the specified ones',
		pt: 'O formato da imagem selecionada é inválido ou as dimensões não atendem às especificações',
	},
	tos: {
		en: 'Terms of service caption on the registration page',
		ge: 'მომსახურების პირობების წარწერა რეგისტრაციის გვერდზე',
		de: 'Nutzungsbedingungen-Beschriftung auf der Registrierungsseite',
		ru: 'Дисклеймер про условия использования на странице регистрации',
		cn: /* TODO: to be translated */'Terms of service caption on the registration page',
		pt: 'Legenda dos Termos de Serviço na página de registro',
	},
	tos_file_label: {
		en: 'Upload your Terms of Service',
		ge: 'ატვირთეთ თქვენი მომსახურების პირობები',
		de: 'Laden Sie Ihre Nutzungsbedingungen hoch',
		ru: 'Загрузите ваши Условия использования',
		cn: /* TODO: to be translated */'Upload your Terms of Service',
		pt: 'Envie seus Termos de Serviço',
	},
	is_whitelabel_enabled: {
		en: 'Enable White-label',
		ge: 'ჩართვა White-label',
		de: 'White-label aktivieren',
		ru: 'Включить white-label',
		cn: 'Enable White-label',	// TODO: to be translated
		pt: 'Habilitar White-label',
	},
	tos_file_preview: {
		en: 'Preview TOS file',
		ge: 'TOS ფაილის გადახედვა',
		de: 'Vorschau der Nutzungsbedingungen',
		ru: 'Посмотреть файл с условиями использования',
		cn: 'Preview TOS file',	// TODO: to be translated
		pt: 'Visualizar arquivo dos Termos de Serviço',
	},
	certificate_status: {
		en: 'HTTPS certificate status',
		ge: 'HTTPS სერტიფიკატის სტატუსი',
		de: 'HTTPS-Zertifikatsstatus',
		ru: 'статус HTTPS сертификата',
		cn: 'HTTPS certificate status',	// TODO: to be translated
		pt: 'Status do certificado HTTPS',
	},
	certificate_status_not_generated: {
		en: 'not generated',
		ge: 'არ არის გენერირებული',
		de: 'nicht generiert',
		ru: 'не сгенерирован',
		cn: 'not generated',	// TODO: to be translated
		pt: 'não gerado',
	},
	certificate_status_generating: {
		en: 'generating',
		ge: 'გენერირება',
		de: 'wird generiert',
		ru: 'генерируется',
		cn: 'generating',	// TODO: to be translated
		pt: 'gerando',
	},
	certificate_status_generated: {
		en: 'generated',
		ge: 'გენერირებული' /* TODO: to be translated */,
		de: 'generiert',
		ru: 'сгенерирован',
		cn: 'generated',	// TODO: to be translated
		pt: 'gerado',
	},
	certificate_status_failed: {
		en: 'failed',
		ge: 'ჩაიშალა',
		de: 'fehlgeschlagen',
		ru: 'ошибка',
		cn: 'failed',	// TODO: to be translated
		pt: 'falhou',
	},
	creative_docs: {
		en: 'Creative documents',
		ge: 'Creative documents',
		de: 'Creative documents',
		ru: 'Документы для креативов',
		cn: 'Creative documents',
		pt: 'Documentos criativos',
	},
	creative_specification_label: {
		en: 'Creative specification',
		ge: 'Creative specification',
		de: 'Creative specification',
		ru: 'Спецификация для креативов',
		cn: 'Creative specification',
		pt: 'Especificação criativa',
	},
	regulatory_docs_label: {
		en: 'Regulatory documents for creatives',
		ge: 'Regulatory documents for creatives',
		de: 'Regulatory documents for creatives',
		ru: 'Регулирующие документы для креативов',
		cn: 'Regulatory documents for creatives',
		pt: 'Documentos regulatórios para criativos',
	},
	confirm_agency_selection: {
		en: 'Confirm agency selection',
		ge: 'Confirm agency selection',  // TODO: translate
		de: 'Confirm agency selection',  // TODO: translate
		ru: 'Подтвердить выбор агентства',
		cn: 'Confirm agency selection',  // TODO: translate
		pt: 'Confirm agency selection',  // TODO: translate
	},
};
